import { render, staticRenderFns } from "./WidgetsTab.vue?vue&type=template&id=640a3fb9"
import script from "./WidgetsTab.vue?vue&type=script&lang=js"
export * from "./WidgetsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports